export function updateWidthOfCdnImage(url: string | undefined, width: number) {
  if (!url) {
    return url;
  }

  return url.replace(/width=\d+/, `width=${width}`);
}
